// extracted by mini-css-extract-plugin
export default {"EmailServicesSpace":"EmailServices_EmailServicesSpace__LgJqu","EmailServices":"EmailServices_EmailServices__O-4nN","FormButtons":"EmailServices_FormButtons__ZGyT+"};